import { Controller } from "@hotwired/stimulus";
import axios from "axios";
import * as Sentry from "@sentry/browser";

export default class CountryCitySelectorController extends Controller {
  connect() {
    this.countrySelect = document.querySelector(".country-select");
    this.citySelect = document.querySelector(".city-select");

    let selectedCountry = this.countrySelect.value;
    if (selectedCountry) {
      // Enable the city selector
      this.citySelect.disabled = false;
    }
  }

  async updateCities() {
    const countryCode = this.countrySelect.dataset.countryCode;
    const locale = this.countrySelect.dataset.locale;

    try {
      await axios({
        method: "get",
        url: `/${countryCode}/${locale}/api/v1/cities/by_country/${this.countrySelect.value}`,
        headers: { Accept: "application/json" },
      }).then((response) => {
        if (response.status == 200) {
          // Remove existing options
          this.citySelect.innerHTML = "";

          // Add new options
          this.appendNewOptions(response.data);

          // Enable the city selector
          this.citySelect.disabled = false;
        } else {
          Sentry.captureMessage(
            "error while updating city selector in vendor sign up form!",
          );
        }
      });
    } catch (error) {
      Sentry.captureException(error);
    }
  }

  appendNewOptions(cities) {
    cities.forEach((city) => {
      const option = document.createElement("option");
      option.value = city.id;
      option.textContent = city.name;
      this.citySelect.appendChild(option);
    });
  }
}
